import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function LabelImportantIcon(props: IconProps) {
    return <Icon {...props} iconKey={"label_important"}/>
}
